export const START_REPORTS = "[REPORTS] STATRT_REPORTS";
export const SET_REPORTS = "[REPORTS] SET_REPORTS";
export const SET_REPORT_LABELS = "[REPORTS] SET_REPORT_LABELS";
export const SET_REPORT_ERROR = "[REPORTS] SET_REPORTS_ERROR";
export const SET_AUDIENCE = "[REPORTS] SET_AUDIENCE";
